// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import Link from 'next/link'
import { FC } from 'react'
import { ComponentProps } from 'react'

import { usePortal } from '../../../../../../app/_providers/PortalProvider.client'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { ProductColorGroupWithUnavailable } from '../../../../../../types/figs'

import { Container, PortalLink, StyledColorAttribute } from './styles'

export interface ColorGroupsSectionProps {
  colorGroups: ProductColorGroupWithUnavailable[]
  hasSelectedSize: boolean
  isCurrentColorCompletelySoldOut: boolean
  isProductWaitlistable: boolean
  onColorSelect: ComponentProps<typeof StyledColorAttribute>['onSelect']
  selectedColorKey: string | undefined
  /* Whether the original color group label should be used. The component will use our singular "color" label if there is only a single color group by default. */
  retainColorGroupLabel?: boolean
}

export const ColorGroupsSection: FC<ColorGroupsSectionProps> = ({
  colorGroups,
  hasSelectedSize,
  isCurrentColorCompletelySoldOut,
  isProductWaitlistable,
  onColorSelect,
  selectedColorKey,
  retainColorGroupLabel = false,
}) => {
  const {
    detailsSection: { colorTitle },
  } = useTranslation()

  const { portal } = usePortal()

  return (
    <Container data-testid='color-swatch-picker'>
      {colorGroups.map(
        cg =>
          cg.colors.length > 0 && (
            <StyledColorAttribute
              key={cg.label}
              title={colorGroups.length === 1 && !retainColorGroupLabel ? colorTitle : cg.label}
              selected={cg.colors.find(({ rawName }) => rawName === selectedColorKey)}
              label={cg.label}
              onSelect={onColorSelect}
              colors={cg.colors}
              withTooltip={retainColorGroupLabel || colorGroups.length > 1}
              soldOut={
                isCurrentColorCompletelySoldOut && !hasSelectedSize && !isProductWaitlistable
              }
            >
              {portal && cg.label === `${portal.name} Uniform` && (
                <Link href={`/portals/${portal.collectionHandle}`} legacyBehavior passHref>
                  <PortalLink href={`/portals/${portal.collectionHandle}`}>
                    {portal.pdpCtaText ?? `Shop ${portal.name} Collection`}
                  </PortalLink>
                </Link>
              )}
            </StyledColorAttribute>
          )
      )}
    </Container>
  )
}
